import { FC } from "react";
import { useIntl } from "react-intl";

interface PromptTipProps {
  labelKey: string;
  dontKey: string;
  doKey: string;
  onClick?: (doText: string) => void;
}

export const PromptTip: FC<PromptTipProps> = ({
  labelKey,
  dontKey,
  doKey,
  onClick,
}) => {
  const { formatMessage } = useIntl();

  const label = formatMessage({ id: labelKey });
  const dontText = formatMessage({ id: dontKey });
  const doText = formatMessage({ id: doKey });

  const handleClick = () => {
    if (onClick) {
      onClick(doText);
    }
  };

  return (
    <div
      className="border border-dashed border-gray-300 rounded-lg pl-3 pr-3 py-2.5 text-xs relative cursor-pointer hover:bg-white transition-colors"
      onClick={handleClick}
    >
      <span className="absolute -top-2 left-3 bg-slate-50 px-1 text-gray-500 text-[10px] tracking-wide font-medium">
        {label}
      </span>
      <div className="mt-1 space-y-1">
        <p className="text-gray-400 flex items-center gap-2">
          <span className="w-4 h-4 rounded-full bg-gray-100 text-gray-400 flex items-center justify-center text-[10px] shrink-0">
            &#x2715;
          </span>
          {dontText}
        </p>
        <p className="text-gray-800 flex items-center gap-2">
          <span className="w-4 h-4 rounded-full bg-green-100 text-green-600 flex items-center justify-center text-[10px] shrink-0">
            &#x2713;
          </span>
          {doText}
        </p>
      </div>
    </div>
  );
};
